import script from "./LeftSidebarFavourites.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftSidebarFavourites.vue?vue&type=script&setup=true&lang=js"

import "./LeftSidebarFavourites.vue?vue&type=style&index=0&id=b42e51ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b42e51ae"]])

export default __exports__